import { useEffect, useState } from "react";
import { RoleDTO, UserClient } from "../services/apiClient";
import axiosInstance from "../services/axiosInstance";
import { API_BASE_URL } from "../config/config";

export const useRoles = () => {
  const [roles, setRoles] = useState<RoleDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const userClient = new UserClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
          const fetchRoles = async () => {
              setIsLoading(true);
              try {
                  const result = await userClient.getRoles();
                  if (result && result.success && result.data) {
                    setRoles(result.data);
                  } else {
                      setError('Failed to fetch roles');
                  }
              } catch (err) {
                  setError('Error fetching roles');
                  console.error('Error fetching roles:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchRoles();
      }, []);
  
      return { roles, isLoading, error };
};
